import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes.ts';
import { useFormContext } from 'react-hook-form';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion.tsx';
import { Box, Divider } from '@mui/material';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext';
import {
  TAdditionalInfoFormContentProps,
  TPepInStore,
} from '~/modules/identification/forms/AdditionalInformation/types.ts';
import { CRSIBlock } from '~/modules/identification/forms/AdditionalInformation/TaxResident/CRSIBlock.tsx';
import { styles as commonStyles } from '~/modules/identification/styles.ts';

export const OtherTaxResident = ({ index }: TAdditionalInfoFormContentProps) => {
  const { isSoleTrader } = useGetContragentTypes();
  const { isCRSIFopEnabled } = useFeatureFlags();
  const { watch, setValue } = useFormContext<TPepInStore>();
  const hasForeignTaxResidency = watch(`additionalInformation.${index}.hasForeignTaxResidency`);

  const isCRSIFop = isSoleTrader && isCRSIFopEnabled;
  const showBlock = hasForeignTaxResidency && isCRSIFop;

  const handleForeignTaxResidency = (isChecked: boolean) => {
    if (!isChecked) {
      setValue(`additionalInformation.${index}.lastName`, null);
      setValue(`additionalInformation.${index}.firstName`, null);
      setValue(`additionalInformation.${index}.middleName`, null);
      setValue(`additionalInformation.${index}.appeals`, null);
      setValue(`additionalInformation.${index}.jurisdictions`, null);
    }
  };

  return (
    <Box>
      {isCRSIFop && (
        <Box sx={{ width: '100%' }}>
          <Divider sx={commonStyles.divider} />
        </Box>
      )}
      <Box sx={{ margin: '20px 0' }}>
        {isCRSIFop && (
          <FormYesNoQuestion
            question="Чи маєте Ви статус податкового резидента іншої юрисдикції (країни) крім України та США?"
            name={`additionalInformation.${index}.hasForeignTaxResidency`}
            onChange={handleForeignTaxResidency}
          />
        )}
      </Box>
      {showBlock ? <CRSIBlock index={index} /> : <Box />}
    </Box>
  );
};
